import { GetProcessStatusApi } from "@/features/accounts/ocr/services/get-process-status-api";
import { GetProcessStatusRequestModel } from "@/features/accounts/ocr/services/get-process-status-model";

/// OCR読み取り結果処理
export class GetProcessStatusService {
  private getProcessStatusApi = new GetProcessStatusApi();
  /**
   * OCR読み取り状況取得API実行
   */
  public async GetProcessStatus(param: GetProcessStatusRequestModel) {
    return await this.getProcessStatusApi.GetProcessStatus(param);
  }
}
